import { createContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../store';
import { SKW_AUTH, SKW_PREFIX, SKW_URL } from '../../utils/constants';

export interface AnchorContextData {
  activeKey: string;
  linkAvatar: string;
  setactiveKey: any;
  setLinkAvatar: any;
}

export const AnchorContext = createContext<AnchorContextData>({} as AnchorContextData);

const AnchorProvider: React.FC = ({ children }) => {
  const token = useSelector((state: ApplicationState) => state.auth.token);
  const [activeKey, setactiveKey] = useState('');
  const [linkAvatar, setLinkAvatar] = useState('');
  useEffect(() => {
    setLinkAvatar(
      `${SKW_URL}/call?serviceName=${SKW_PREFIX}obterImagemUsuario&accessKey=${SKW_AUTH}&token=${token}`
    );
  }, [token]);

  return (
    <AnchorContext.Provider value={{ activeKey, setactiveKey, linkAvatar, setLinkAvatar }}>
      {children}
    </AnchorContext.Provider>
  );
};

export default AnchorProvider;
